import { arrayOf, shape, string } from 'prop-types';

export const partnerType = shape({
  fullname: string,
  image: string,
});

export const partnersType = arrayOf(partnerType);
